<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="appointmentOrderVO.pkid > 0 ? '编辑' : '新建'"
      class="appointmentOrder-edit"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="appointmentOrderVO"
        :rules="ruleValidate"
        class="form"
        label-width="110px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="系统编号">
            <el-input v-model="appointmentOrderVO.billNo" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工作时间">
            <el-date-picker
                v-model="appointmentOrderVO.creatTime"
                style="width: 100%"
                type="datetime"
                disabled
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="登记人">
            <el-input v-model="appointmentOrderVO.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="小微产品线" prop="productLine">
            <el-select v-model="appointmentOrderVO.productLine" filterable placeholder="请选择">
              <el-option
                  v-for="item in ProductLineOptions"
                  :key="item.itemValue"
                  :label="item.itemValue"
                  :value="item.itemValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="型号(多选)" prop="transducerModel" :rules="[{ required: true, message: '请选择型号', trigger: 'blur' }]">
            <el-select v-model="transducerModels" filterable multiple placeholder="请选择">
              <el-option v-for="item in TransducerModelOptions" :key="item.itemID" :label="item.itemValue" :value="item.itemValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备名称" prop="equipmentName">
            <el-input v-model="appointmentOrderVO.equipmentName" placeholder="客户设备名称，行业设备名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="(直线)客户名称" prop="customerName">
            <el-input v-model="appointmentOrderVO.customerName" readonly placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.selectCustomer.open()">
                选择
              </el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="终端客户(现场)" prop="siteName">
            <el-input
                v-model="appointmentOrderVO.siteName"
                readonly
                placeholder="请输入"
                clearable
            >
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.selectFinalCustomer.open()">
                选择
              </el-button>
            </el-input>
            <customer-select ref="selectFinalCustomer" @select="selectFinalCustomer"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="工作过程总结" prop="maintainNote">
            <el-input
                v-model="appointmentOrderVO.maintainNote"
                type="textarea"
                placeholder="详细记录处理过程、参数排查、遇到问题的处理对策、处理过程的技术经验"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="130px" label="技术支持初步判断" prop="initDecide">
            <el-select v-model="appointmentOrderVO.initDecide" filterable placeholder="请选择">
              <el-option v-for="item in InitDecideOptions" :key="item.itemId" :label="item.itemValue" :value="item.itemValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="当前状态" prop="isFinish">
            <el-select v-model="appointmentOrderVO.isFinish" placeholder="请选择">
              <el-option label="已完结" :value="true"/>
              <el-option label="未完结" :value="false"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="未完成跟进" prop="unfinishedNote">
            <el-select v-model="appointmentOrderVO.unfinishedNote" allow-create filterable placeholder="请选择">
              <el-option label="需技术支持跟进" value="需技术支持跟进"/>
              <el-option label="需产品、研发、项目组跟进" value="需产品、研发、项目组跟进"/>
              <el-option label="已输出结果-关闭问题状态" value="已输出结果-关闭问题状态"/>
            </el-select>
          </el-form-item>
        </el-col>
       
        <el-col :span="24">
          <el-form-item label-width="130px" label="已关闭问题原因分析" prop="causeNote" :rules="[{ required: !!appointmentOrderVO.isFinish, message: '请输入已关闭问题原因分析', trigger: 'blur' }]">
            <el-input v-model="appointmentOrderVO.causeNote" type="textarea" placeholder="原因复盘"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工作类型" prop="workerType">
            <el-select v-model="appointmentOrderVO.workerType" filterable placeholder="请选择">
              <el-option label="现场出差" value="现场出差"/>
              <el-option label="线上远程" value="线上远程"/>
              <el-option label="电话远程" value="电话远程"/>
              <el-option label="400电话" value="400电话"/>
              <el-option label="配合研发测试" value="配合研发测试"/>
              <el-option label="维修测试" value="维修测试"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="业务需求" prop="businessRequirements">
            <el-select v-model="appointmentOrderVO.businessRequirements" filterable placeholder="请选择">
              <el-option v-for="item in BusinessRequirementsOptions" :key="item.itemId" :label="item.itemValue" :value="item.itemValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="需协助跟进人员" prop="assistant">
            <el-select v-model="assistants" filterable multiple placeholder="请选择">
              <el-option
                  v-for="item in assistantsOptions"
                  :key="item.itemID"
                  :label="item.employeeName + '(' + item.userName + ')'"
                  :value="item.employeeName"/>
            </el-select>
            <!-- <el-input v-model="appointmentOrderVO.assistant" placeholder="请选择" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectAssistant.open()"/>
            </el-input>
            <user-select ref="selectAssistant" :is-multi-select="true" @select="onSelectAssistant"/> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="销售工程师" prop="salesmanName">
            <el-input v-model="appointmentOrderVO.salesmanName" placeholder="请选择" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectSupplierManage.open()"/>
            </el-input>
            <user-select ref="selectSupplierManage" @select="onSelectSalesPerson"/>
          </el-form-item>
        </el-col>
     
        <el-col :span="8">
          <el-form-item label="服务时长/h" prop="serviceTime">
            <el-input v-model="appointmentOrderVO.serviceTime" placeholder="工作时长"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="产品二维码扫码" prop="machineSerialNo">
            <el-input v-model="appointmentOrderVO.machineSerialNo" placeholder="扫码"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div>
        <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
        <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            v-if="appointmentOrderVO.attachments"
            ref="payData1"
            :data="appointmentOrderVO.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>
 
<script>
  // import constants from "../../../util/constants";
  import loginUtil from "@/util/loginUtil";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import UploadFile from "@/components/UploadFile";

  export default {
    name: "AppointmentEdit",
    components: {UploadFile, CustomerSelect, UserSelect},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        ProductLineOptions: [],
        TransducerModelOptions: [],
        InitDecideOptions: [],
        BusinessRequirementsOptions: [],
        transducerModels: [],
        assistants: [],
        assistantsOptions: [],
        appointmentOrderVO: {
          pkid: "",
          billNo: "",
          creatTime: "",
          appointmentTime: "",
          creatorName: loginUtil.getName(),
          // 新增字段
          submitTime: "", //工作时间
          productLine: "", //小产品线
          customerId: "",
          customerName: "",
          siteId: "", //终端客户ID
          siteName: "", //终端客户
          transducerModel: [], //型号(多选)
          equipmentName: "", //设备名称
          maintainNote: "", //详细记录处理过程
          initDecide: "", //技术支持初步判断
          isFinish: "", //当前状态
          unfinishedNote: "", //未完成跟进
          causeNote: "", //已关闭问题原因分析
          workerType: "", //工作类型
          businessRequirements: "", //业务需求
          assistant: "", //帮助跟进人员
          salesmanName: "", //销售工程师
          serviceTime: "", //服务时长/h
          machineSerialNo: "", //产品二维码扫码
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空",trigger: "change"},
          appointmentTime: {required: true, message: "不能为空",trigger: "change"},
          siteName: {required: true, message: "不能为空",trigger: "change"},
          productLine: {required: true, message: "不能为空",trigger: "change"},
          transducerModel: {required: true, message: "不能为空",trigger: "change"},
          equipmentName: {required: true, message: "不能为空",trigger: "blur"},
          maintainNote: {required: true, message: "不能为空",trigger: "blur"},
          initDecide: {required: true, message: "不能为空",trigger: "blur"},
          isFinish: {required: true, message: "不能为空",trigger: "change"},
          unfinishedNote: {required: true, message: "不能为空",trigger: "blur"},
          workerType: {required: true, message: "不能为空",trigger: "change"},
          businessRequirements: {required: true, message: "不能为空",trigger: "change"},
          serviceTime: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.appointmentOrderVO.pkid = row.pkid;
          if(this.appointmentOrderVO.pkid>0) {
            this.getData();
          }
        }
        this.getTemplateList();
      },
      getData() {
        this.$http
          .get("basic", `appointmentOrders/${this.appointmentOrderVO.pkid}`)
          .then(resp => {
            this.appointmentOrderVO = resp.data;
            this.transducerModels = this.appointmentOrderVO.transducerModel.split(",");
            this.assistants = this.appointmentOrderVO.assistant.split(",");
            this.appointmentOrderVO.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });

            });
          });
      },
      fileDelete(row,index) {
        this.appointmentOrderVO.attachments.splice(index, 1);
      },
      getTemplateList() {
        this.$http
          .get("basic", "appointmentOrders/selectTypeList")
          .then(resp => {
            if(resp.success) {
              const { ProductLine, TransducerModel, InitDecide, BusinessRequirements } = resp.data;
              this.ProductLineOptions = ProductLine;
              this.TransducerModelOptions = TransducerModel;
              this.InitDecideOptions = InitDecide;
              this.BusinessRequirementsOptions = BusinessRequirements;
            }
          });
        this.$http
          .get("basic", "system/user/selectAllList")
          .then(resp => {
            if (resp.success) {
              this.assistantsOptions = resp.data;
            }
          });
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.appointmentOrderVO.attachments.push(params);
        }
      },
      onSelectSalesPerson(row) {
        this.appointmentOrderVO.salesmanId = row.systemUserID;
        this.appointmentOrderVO.salesmanName = row.employeeName;
      },
      onSelectAssistant(row) {
        this.appointmentOrderVO.assistantId = row.systemUserID;
        this.appointmentOrderVO.assistant = row.employeeName;
      },
      selectCustomer(row) {
        this.appointmentOrderVO.customerName = row.customerName;
        this.appointmentOrderVO.customerId = row.customerID;
      },
      selectFinalCustomer(row) {
        this.appointmentOrderVO.siteName = row.customerName;
        this.appointmentOrderVO.siteId = row.customerID;
      },
      handleSubmit() {
        this.appointmentOrderVO.transducerModel = this.transducerModels.join(",");
        this.appointmentOrderVO.assistant = this.assistants.join(",");
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.appointmentOrderVO.isSubmit = false;
            if(this.appointmentOrderVO.pkid>0) {
              this.$http
                .put("basic", "appointmentOrders", this.appointmentOrderVO)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }else {
              this.$http
                .post("basic", "appointmentOrders", this.appointmentOrderVO)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>